import { Component,  Inject } from '@angular/core';

import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ConfirmDialog } from './confirmDialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'sura-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {

  img:any;
  imgs: any[] = [];

  constructor(public dialogConfirm: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialog,
    private _sanitizationService: DomSanitizer) {  
     const rawImgs = this.data.wr.img || ''; // ejemplo: "foto1.png,foto2.png"
        const imgArray = rawImgs.split(',').map((img: string) => img.trim()).filter(Boolean);

        this.imgs = imgArray.map((img: string) =>{
          //this._sanitizationService.bypassSecurityTrustResourceUrl(environment.apiEndpoint + 'ajax/' + img)
          const url = img.startsWith('https') ? img : environment.apiEndpoint + 'ajax/' + img; return this._sanitizationService.bypassSecurityTrustResourceUrl(url);
        });
     }

  ngOnInit() {
  
  }
  closeConfirmDialog(){
    this.dialogConfirm.close();
  }
  confirmDialog(){
    this.data.flagRespuesta = true;
    this.dialogConfirm.close(this.data); 
  }
}